import { Trans } from '@lingui/react/macro';

export const BuyDialogSizeSelector = ({ variations, value, onChange }) => (
  <div>
    <header className="text-center font-extrabold text-lg md:text-3xl uppercase text-black leading-6 md:leading-10">
      <Trans>What size would you like?</Trans>
    </header>
    <div className="flex justify-center mt-3 md:mt-5 md:mb-2">
      {variations.map((variation) => (
        <div key={variation.size}>
          <input
            id={`tee-size-${variation.size}`}
            className="hidden"
            type="radio"
            checked={value === variation.size}
            value={variation.size}
            onChange={(e) => {
              onChange(e.currentTarget.value);
            }}
          />
          <label
            htmlFor={`tee-size-${variation.size}`}
            className="h-8 w-9 md:h-16 md:w-[4.375rem] text-sm md:text-3xl flex justify-center items-center bg-qw-blue-500 hover:bg-qw-green border-solid border-2 md:border-[3px] border-black text-white font-bold rounded-lg md:rounded-xl mx-0.5 cursor-pointer"
          >
            {variation.size === 'STK'
              ? 'STK'
              : variation.size.replace(/^(PH|[WKHPS])(.+)/, '$2')}
          </label>
        </div>
      ))}
    </div>
  </div>
);
